// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"001974d2","159":"03da8a06","453":"d855a71b","491":"06d9aeab","558":"3ce652b9","585":"2c094578"}[chunkId] + ".chunk.js";
};